'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularUiBootstrap = require('angular-ui-bootstrap');

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _angularFilter = require('angular-filter');

var _angularFilter2 = _interopRequireDefault(_angularFilter);

var _common = require('./common/common');

var _common2 = _interopRequireDefault(_common);

var _modules = require('./modules');

var _modules2 = _interopRequireDefault(_modules);

var _ui = require('./ui');

var _ui2 = _interopRequireDefault(_ui);

require('normalize.css');

require('../assets/css/AdminLTE.css');

require('../assets/css/skin-blue.css');

require('../assets/css/bootstrap-v-tabs.css');

require('../assets/css/style.css');

var _uiSelect = require('ui-select');

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _auth = require('./common/auth/auth.html');

var _auth2 = _interopRequireDefault(_auth);

var _layout = require('./common/layout.html');

var _layout2 = _interopRequireDefault(_layout);

require('ui-select/dist/select.css');

var _angularLoadingBar = require('angular-loading-bar');

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log(_angularLoadingBar2.default);
_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _modules2.default, _ui2.default, 'ngStorage', _angularUiBootstrap2.default, _angularFilter2.default, _uiSelect2.default, _angularLoadingBar2.default])
// .constant("APPLICATION_URL", 'http://localhost:8000')
// .constant("API_URL", 'http://localhost:4000')
.constant("APPLICATION_URL", 'https://signlabs.se').constant("API_URL", 'http://46.101.182.153:4000')

// Pacsoft ==> Unifaun
.constant("UNIFAUN_ID", 'N4N5DFXWY7HNGAVI').constant("UNIFAUN_SECRET", 'DQMJEM5ORXAPXIJR2XZC2WJC')

// Unifaun Test Account
// .constant("UNIFAUN_ID", 'ZRIUPEMMDWR656B7')
// .constant("UNIFAUN_SECRET", 'ZAKOJ6ALCA5JED5WSUCAEY6U')

.config(function ($locationProvider, $stateProvider, $urlRouterProvider) {
  "ngInject";
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode

  $locationProvider.html5Mode(true).hashPrefix('!');

  $stateProvider.state('auth', {
    url: '/auth',
    abstract: true,
    template: _auth2.default
  });
  $stateProvider.state('auth.login', {
    url: '/login',
    template: '<loginform>',
    data: {
      noLogin: true
    }
  });

  $stateProvider.state('app', {
    template: _layout2.default,
    url: '/',
    resolve: {
      data: function data(ProductsDataProvider, ProductPartsDataProvider, $q) {
        "ngInject";

        return $q.all([ProductsDataProvider.loadProducts(), ProductPartsDataProvider.loadShapes(), ProductPartsDataProvider.loadColors(), ProductPartsDataProvider.loadFixmethods()]);
      }
    },
    controller: function controller($scope, data, AuthService, $state) {
      $scope.products = data[0];
      $scope.logout = function ($event) {
        $event.preventDefault();
        AuthService.logout();
        $state.go('auth.login');
      };
    }
  });

  $urlRouterProvider.otherwise(function ($injector, $location) {
    var $state = $injector.get("$state");
    $state.go("app");
  });
}).run(function ($rootScope, $state, AuthService) {
  "ngInject";

  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, fromState) {
    //return;
    if (!('data' in next) || true !== next.data.noLogin) {
      if (!AuthService.getCurrentUser()) {
        event.preventDefault();
        $state.go('auth.login');
      }
    }
  });
});

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/app.js
 **/